import { createContext } from 'react';
import type { Dispatch } from 'react';

import { initialAction, initialState } from './initial';

const RichTextEditorValueContext =
  createContext<typeof initialState>(initialState);

const RichTextEditorActionContext = createContext<
  Dispatch<typeof initialAction>
>(() => {});

export { RichTextEditorActionContext, RichTextEditorValueContext };
